import React from 'react'
import { View } from 'dripsy'
import useWebHeaderHeight from './use-web-header-height'
import { Platform } from 'react-native'

type Props = {
  /**
   * If defined, uses this value. Otherwise, is 0 on mobile.
   */
  enabledOnMobile?: 'safe' | 'full-height'
} & React.ComponentProps<typeof View>

export default function WebHeaderSpacer(props: Props) {
  const { sx = {}, enabledOnMobile, ...viewProps } = props
  const { height, top } = useWebHeaderHeight()
  return (
    <View
      {...viewProps}
      sx={{
        height: Platform.select({
          web: height,
          default:
            enabledOnMobile === 'full-height'
              ? height
              : enabledOnMobile === 'safe'
              ? top
              : undefined,
        }),
        bg: 'background',
        ...sx,
      }}
      pointerEvents="none"
    />
  )
}
